import { render, staticRenderFns } from "./SortingDropdown.vue?vue&type=template&id=311d64a0&scoped=true"
import script from "./SortingDropdown.vue?vue&type=script&lang=js"
export * from "./SortingDropdown.vue?vue&type=script&lang=js"
import style0 from "./SortingDropdown.vue?vue&type=style&index=0&id=311d64a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311d64a0",
  null
  
)

export default component.exports